import maxBy from "lodash/maxBy";
import { connect } from "react-redux";
import { batchActions } from "redux-batched-actions";
import { getRank } from "roles";
import { ClanLeaveDialog } from "UIKit";
import { clanDisband, clanLeave, forceAccountSync, selectCommander, setInitialState, toggleFetching } from "../Actions/ActionClanLeave";
import { changeCommander, closeLeaveDialog } from "../Actions/ActionClanProfile";
import { hideDialog, showDialog } from "../Actions/ActionDialog";

const mapStateToProps = state => {
  const accountId = state.currentAccount.id;
  const clanId = state.currentAccount.clanId;
  const isCommander = state.currentAccount.roleName === 'commander';
  let members = [];
  if (state.members && clanId) {
    members = state.members.clans[clanId].members.filter(item => item.id !== accountId);
  }

  let newCommander = null;
  if (isCommander && state.clanLeave.newCommanderId) {
    newCommander = members.find(member => member.id === state.clanLeave.newCommanderId);
  }

  if (isCommander && !newCommander) {
    newCommander = maxBy(members, member => getRank(member.roleName));
  }

  return {
    isFetching: state.clanLeave.isFetching,
    newCommander,
    members: members
  };
};

const processSuccessLeaveOrDisband = (dispatch, isLeave) => {
  dispatch(forceAccountSync(isLeave)).then(() => {
    dispatch(batchActions([setInitialState(), hideDialog(), closeLeaveDialog()]));
  });
};

const mapDispatchToProps = dispatch => {
  const onLeaveClanSubmit = () => {
    dispatch(clanLeave()).then(isSuccess => {
      isSuccess && processSuccessLeaveOrDisband(dispatch, true);
    });
  };
  return {
    onChangeCommander: newCommanderId => {
      dispatch(toggleFetching());
      dispatch(changeCommander(newCommanderId, true)).then(isSuccess => {
        dispatch(toggleFetching());
        isSuccess && onLeaveClanSubmit();
      });
    },
    onLeaveClanSubmit: onLeaveClanSubmit,
    onDisbandClan: () => {
      dispatch(clanDisband()).then(isSuccess => {
        isSuccess && processSuccessLeaveOrDisband(dispatch, false);
      });
    },
    onShowDialog: (content, size) => dispatch(showDialog(content, size)),
    onHideDialog: () => {
      dispatch(hideDialog());
      dispatch(closeLeaveDialog());
    },
    onSelectCommander: newCommanderId => dispatch(selectCommander(newCommanderId))


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClanLeaveDialog);